import { ApiClient } from '@dozuki/web-js/utils';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { useLocalization } from '~/framework';
import { useApiErrorMessageToast } from '~/pages/_shared';
import { getGuideFromClient } from '~/pages/api/guides';
import { GetGuideErrorCode } from '~/pages/api/guides/getGuide.api';
import { GetGuideRequestOption, getGuide } from '~/monolith-api/guides';

const KEY = 'guide';

export function getGuideKey(guideid: number | null, options?: GetGuideRequestOption) {
   if (options) {
      return [KEY, guideid, options];
   } else {
      return [KEY, guideid];
   }
}

export function useGuide(guideid: number | null, options: GetGuideRequestOption = {}) {
   const { _js } = useLocalization();
   const { handleErrorOrRedirectToLogin } = useApiErrorMessageToast<GetGuideErrorCode>({
      'guides.guide_not_found': _js('Could not find selected guide'),
      default: _js('There was a problem retrieving the selected guide; please try again'),
   });

   return useQuery({
      queryFn: async () => {
         if (guideid === null) return null;
         return await getGuideFromClient(guideid, options);
      },
      queryKey: getGuideKey(guideid, options),
      onError: handleErrorOrRedirectToLogin,
   });
}

export async function prefetchGuide(
   guideid: number,
   apiClient: ApiClient,
   queryClient: QueryClient,
   options: GetGuideRequestOption = {}
): Promise<void> {
   await queryClient.fetchQuery(getGuideKey(guideid, options), () =>
      getGuide(guideid, { ...options, apiClient })
   );
}
